module.exports = __webpack_public_path__ + "static/img/p_03.7e9c728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p_03.png
// module id = 606
// module chunks = 1